// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts,js_import_style=legacy_commonjs"
// @generated from file fusebase/app_analytics/v1/event_type.proto (package fusebase.app_analytics.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { proto3 } = require("@bufbuild/protobuf");

/**
 * @generated from enum fusebase.app_analytics.v1.EventType
 */
const EventType = /*@__PURE__*/ proto3.makeEnum(
  "fusebase.app_analytics.v1.EventType",
  [
    {no: 0, name: "EVENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EVENT_TYPE_USER_VIEWED_PAGE", localName: "USER_VIEWED_PAGE"},
    {no: 2, name: "EVENT_TYPE_USER_ENTERED_BLOCK_EDIT_MODE", localName: "USER_ENTERED_BLOCK_EDIT_MODE"},
    {no: 3, name: "EVENT_TYPE_USER_EXITED_BLOCK_EDIT_MODE", localName: "USER_EXITED_BLOCK_EDIT_MODE"},
    {no: 4, name: "EVENT_TYPE_USER_UPLOADED_FILE", localName: "USER_UPLOADED_FILE"},
    {no: 5, name: "EVENT_TYPE_USER_DOWNLOADED_FILE", localName: "USER_DOWNLOADED_FILE"},
    {no: 6, name: "EVENT_TYPE_USER_RENAMED_FILE", localName: "USER_RENAMED_FILE"},
    {no: 7, name: "EVENT_TYPE_USER_DELETED_FILE", localName: "USER_DELETED_FILE"},
    {no: 8, name: "EVENT_TYPE_USER_VIEWED_VIDEO", localName: "USER_VIEWED_VIDEO"},
    {no: 9, name: "EVENT_TYPE_USER_CREATED_TASK", localName: "USER_CREATED_TASK"},
    {no: 10, name: "EVENT_TYPE_USER_DELETED_TASK", localName: "USER_DELETED_TASK"},
    {no: 11, name: "EVENT_TYPE_USER_REQUESTED_PORTAL_ACCESS", localName: "USER_REQUESTED_PORTAL_ACCESS"},
    {no: 12, name: "EVENT_TYPE_USER_FOLLOWED_LINK", localName: "USER_FOLLOWED_LINK"},
  ],
);


exports.EventType = EventType;
